import { render, staticRenderFns } from "./placementExam.vue?vue&type=template&id=05d74e3f&"
import script from "./placementExam.vue?vue&type=script&lang=js&"
export * from "./placementExam.vue?vue&type=script&lang=js&"
import style0 from "./placementExam.vue?vue&type=style&index=0&lang=css&"
import style1 from "./placementExam.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports